import { MutationFunction } from "@tanstack/react-query"
import log from "loglevel"
import { useEffect } from "react"
import { API, NexusSuccessResponse } from "../../api/API"
import { useNexusDataReceiptIdOptional } from "../../hooks/useNexusParams"
import { ConfirmationRoutes } from "../../routing/NexRoutes"
import { prettyJson } from "../../tools"
import { useDataReceiptStore } from "../../zstore/DataReceiptStore"
import { DataReceiptEditor } from "./DataReceiptEditor"

export const ManageDataReceipt = () => {
    const dataReceiptId = useNexusDataReceiptIdOptional()

    const fetchDataReceiptFormData = useDataReceiptStore((state) => state.fetchDataReceiptFormData)
    const getDataReceiptForCreation = useDataReceiptStore((state) => state.getDataReceiptForCreation)
    const clearState = useDataReceiptStore((state) => state.clearState)

    useEffect(() => {
        if (dataReceiptId) {
            fetchDataReceiptFormData(dataReceiptId)
        }
        return clearState
    }, [])

    let mutationFn: MutationFunction<NexusSuccessResponse<unknown>, void> | undefined
    let confirmationRoute: ConfirmationRoutes
    let pageTitle: string
    if (dataReceiptId) {
        pageTitle = "View Data Receipt"
        mutationFn = () => {
            const payload = getDataReceiptForCreation()
            log.info(`Update DataReceipt: ${prettyJson(payload)}`)
            return API.put(`/data-receipt/${dataReceiptId}`, payload, "Couldn't edit Data Receipt.")
        }
        confirmationRoute = ConfirmationRoutes.DATA_RECEIPT_UPDATED
    } else {
        pageTitle = "Create Data Receipt"
        mutationFn = () => {
            const payload = getDataReceiptForCreation()
            log.info(`Send DataReceipt: ${prettyJson(payload)}`)
            return API.post("/data-receipt", payload, "Couldn't submit Data Receipt.")
        }
        confirmationRoute = ConfirmationRoutes.DATA_RECEIPT_SUBMITTED
    }

    return <DataReceiptEditor mutationFn={mutationFn} confirmationRoute={confirmationRoute} pageTitle={pageTitle} />
}
